import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { CheckCircle } from 'lucide-react';

export default function Courses() {
  const week1 = [
    { class: 1, title: "Introduction to Digital World", desc: "डिजिटल और सोशल मीडिया क्या है आज के समय में सोशल मीडिया की सम्पूर्ण डिजिटल एप्लीकेशन की बेसिक जानकारी" },
    { class: 2, title: "Social Media Platforms Overview", desc: "YouTube, Facebook, Instagram, X (Twitter) - सोशल मीडिया कैसे काम करता है" },
    { class: 3, title: "Personal Branding", desc: "सोशल मीडिया पर अपनी पहचान बनाना प्रोफेशनल ऑप्टिमाइजेशन" },
    { class: 4, title: "Business Branding", desc: "अपने बिजनेस को सोशल मीडिया पर प्रमोट करना" },
    { class: 5, title: "Content Selection & Research", desc: "अच्छा कंटेंट कैसे खोजें ट्रेंडिंग मुद्दों की रिसर्च" },
    { class: 6, title: "Video Creation Basics", desc: "मोबाइल से प्रोफेशनल वीडियो बनाना" }
  ];

  const week2 = [
    { class: 7, title: "Photo Editing", desc: "मोबाइल ऐप से फोटो एडिटिंग बेसिक एडिटिंग टूल्स" },
    { class: 8, title: "Thumbnail Editing", desc: "यूट्यूब चैनल का महत्व आकर्षक चैनल डिजाइन करना" },
    { class: 9, title: "Video Editing", desc: "मोबाइल से वीडियो एडिटिंग कट, ट्रांसिशन और टेक्स्ट एडिटिंग" },
    { class: 10, title: "Content Uploading", desc: "यूट्यूब वीडियो अपलोड करना SEO, Title, Description, Tags" },
    { class: 11, title: "Digital Income & Monetization", desc: "YouTube Monetization, Facebook Income, Brand Promotion & Sponsorship" },
    { class: 12, title: "Cyber Safety & Online Security", desc: "साइबर क्राइम से बचाव सोशल मीडिया सुरक्षा" }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <WhatsAppButton />

      <section className="bg-gradient-to-br from-orange-500 to-red-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-extrabold font-heading mb-6"
            data-testid="courses-title"
          >
            15 Days Digital Success Program
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-2xl font-bold"
          >
            Learn • Earn • Promote • Grow
          </motion.p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <img 
              src="https://customer-assets.emergentagent.com/job_digital-research-hub/artifacts/gnoer5gp_poster.png" 
              alt="Course Structure" 
              className="mx-auto rounded-2xl shadow-2xl max-w-4xl w-full"
            />
          </div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16"
          >
            <h2 className="text-4xl font-bold font-heading text-center mb-12">
              <span className="gradient-text">Week 1</span> - Digital Foundation
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {week1.map((item, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all border-l-4 border-orange-500"
                  data-testid={`week1-class-${index}`}
                >
                  <div className="flex items-start gap-3 mb-3">
                    <div className="bg-orange-500 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0">
                      {item.class}
                    </div>
                    <h3 className="font-bold text-gray-900 text-lg">{item.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm font-hindi pl-11">{item.desc}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16"
          >
            <h2 className="text-4xl font-bold font-heading text-center mb-12">
              <span className="gradient-text">Week 2</span> - Editing Skills & Online Income
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {week2.map((item, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all border-l-4 border-blue-500"
                  data-testid={`week2-class-${index}`}
                >
                  <div className="flex items-start gap-3 mb-3">
                    <div className="bg-blue-500 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0">
                      {item.class}
                    </div>
                    <h3 className="font-bold text-gray-900 text-lg">{item.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm font-hindi pl-11">{item.desc}</p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-green-50 to-white p-8 rounded-2xl shadow-xl border-2 border-green-200"
          >
            <h2 className="text-3xl font-bold font-heading text-center mb-8 text-green-800">
              Final Training Days
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="text-4xl font-bold text-green-600 mb-2">Day 13</div>
                <h3 className="font-bold text-gray-900 mb-2">Personality Development</h3>
                <p className="text-gray-600 font-hindi text-sm">कैमरे के सामने बोलना कम्युनिकेशन स्किल्स</p>
              </div>
              <div className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="text-4xl font-bold text-green-600 mb-2">Day 14</div>
                <h3 className="font-bold text-gray-900 mb-2">AI Session & Assessment</h3>
                <p className="text-gray-600 font-hindi text-sm">टेस्ट और एडिटिंग स्किल्स का मूल्यांकन</p>
              </div>
              <div className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="text-4xl font-bold text-green-600 mb-2">Day 15</div>
                <h3 className="font-bold text-gray-900 mb-2">Certificate Distribution</h3>
                <p className="text-gray-600 font-hindi text-sm">सर्टिफिकेट वितरण समारोह</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}